// ==========================================================================
// RepeatController
// ==========================================================================

import { toggleClass, toggleHidden } from '../utils/elements';
import { on, off, once } from '../utils/events';
import is from '../utils/is';
import { silencePromise } from '../utils/promise';
import controls from '../controls';


class RepeatController {

  constructor(player) {
    this.player = player;
    this.repeat = this.player.displayRepeat;

    this.beginElement = null;
    this.endElement = null;
    this.player.beginTime = 0;
    this.player.endTime = this.player.duration;

    this.render();

    on.call(this.player, this.player.elements.buttons.repeat, 'click', () => {
      this.repeat = !this.repeat;
      this.player.displayRepeat = this.repeat;
      this.player.elements.buttons.repeat.pressed = this.repeat;

      if (this.repeat) {
        this.player.beginTime = 0;
        this.beginElement.style.left = '0%';
        this.player.endTime = this.player.duration;
        this.endElement.style.left = '100%';
      }

      this.player.elements.buttons.repeat.setAttribute('aria-expanded', this.repeat);

      toggleHidden(this.beginElement, !this.repeat);
      toggleHidden(this.endElement, !this.repeat);

      toggleClass(this.beginElement, 'plyr__repeat-a-controller--is-shown', this.repeat);
      toggleClass(this.endElement, 'plyr__repeat-b-controller--is-shown', this.repeat);

      this.player.elements.buttons.repeat.blur();
    });


    on.call(this.player, this.player.media, 'timeupdate', () => {
      if (this.repeat) {
        const currentTime = this.player.currentTime;
        if (currentTime < this.player.beginTime - 0.5) {
          this.player.currentTime = this.player.beginTime;
        } else if (currentTime >= this.player.endTime) {
          this.player.currentTime = this.player.beginTime;
        }
      }
    });

    on.call(this.player, this.player.media, 'ended', () => {
      if (this.repeat) {
        this.player.currentTime = this.player.beginTime;
        silencePromise(this.player.play());
      }
    });

    on.call(this.player, this.beginElement, 'mousedown touchstart', (event) => {
      //  this.player.debug.log('RepeatController-a', event.type);

      const dragMove = (event) => {
        // this.player.debug.log('RepeatController-a', event.type);
        const currentTime = this.player.currentTime;
        const currentPercent = currentTime / this.player.duration * 100;
        const endPercent = (this.player.endTime - 1) / this.player.duration * 100;

        const rect = this.player.elements.progress.getBoundingClientRect();
        let percent = (100 / rect.width) * (this.getPageX(event) - rect.left);
        if (percent < 0) {
          percent = 0;
        } else if (percent > currentPercent) {
          percent = currentPercent;
        } else if (percent > endPercent) {
          percent = endPercent;
        }

        this.beginElement.style.left = `${percent}%`;
        this.player.beginTime = (this.player.duration / 100) * percent;

        controls.updateTimeDisplay.call(
          this,
          this.player.elements.display.currentTime,
          this.player.beginTime,
        );

        if (is.element(event)) {
          event.preventDefault();
        }
      }

      on.call(this.player, this.player.elements.container, 'mousemove touchmove', dragMove);
      once.call(this.player, this.player.elements.container, 'mouseup touchend', (event) => {
        // this.player.debug.log('RepeatController-a', event.type);
        off.call(this.player, this.player.elements.container, 'mousemove touchmove', dragMove);
        if (!this.player.playing) {
          if (this.player.beginTime > this.player.currentTime) {
            this.player.currentTime = this.player.beginTime;
          }
        }
      });

      if (is.element(event)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    on.call(this.player, this.endElement, 'mousedown touchstart', (event) => {
      // this.player.debug.log('RepeatController-b', event.type);

      const dragMove = (event) => {
        // this.player.debug.log('RepeatController-b', event.type);

        const currentTime = this.player.currentTime;
        const currentPercent = (currentTime + 1) / this.player.duration * 100;
        const beginPercent = (this.player.beginTime + 1) / this.player.duration * 100;

        const rect = this.player.elements.progress.getBoundingClientRect();
        let percent = (100 / rect.width) * (this.getPageX(event) - rect.left);
        if (percent < currentPercent) {
          percent = currentPercent;
        } else if (percent < beginPercent) {
          percent = beginPercent;
        } else if (percent > 100) {
          percent = 100;
        }

        this.endElement.style.left = `${percent}%`;
        this.player.endTime = (this.player.duration / 100) * percent;

        controls.updateTimeDisplay.call(
          this,
          this.player.elements.display.currentTime,
          this.player.endTime,
        );

        if (is.element(event)) {
          event.preventDefault();
        }
      }

      on.call(this.player, this.player.elements.container, 'mousemove touchmove', dragMove);

      once.call(this.player, this.player.elements.container, 'mouseup touchend', (event) => {
        // this.player.debug.log('RepeatController-b', event.type);
        off.call(this.player, this.player.elements.container, 'mousemove touchmove', dragMove);
        if (!this.player.playing) {
          if (this.player.endTime < this.player.currentTime) {
            this.player.currentTime = this.player.endTime;
          }
        }
      });

      if (is.element(event)) {
        event.preventDefault();
        event.stopPropagation();
      }

    });
  }

  getPageX = (event) => {
    return event.changedTouches ? event.changedTouches[0].pageX : event.pageX;
  }

  render = () => {
    if (is.element(this.player.elements.progress)) {
      this.beginElement = controls.createButton.call(this.player, 'repeat-begin', { class: 'plyr__repeat-a-controller' })
      this.beginElement.hidden = true;
      this.player.elements.progress.appendChild(this.beginElement);
      this.endElement = controls.createButton.call(this.player, 'repeat-end', { class: 'plyr__repeat-b-controller' })
      this.endElement.hidden = true;
      this.player.elements.progress.appendChild(this.endElement);
    }
  }

  destroy = () => {
    if (this.beginElement) {
      this.beginElement.remove();
    }
    if (this.endElement) {
      this.endElement.remove();
    }
  };

}

export default RepeatController;